import Helper from "./Helper";

class ScrollAnimate {
  constructor() {
    const selectors = `.ns-video-section-content__box`;
    const elements = Array.prototype.slice.call(
      document.querySelectorAll(selectors)
    );
    elements.forEach((e) => {
      if (!Helper.isInViewport(e)) {
        Helper.addClass(e, "animate");
      } else {
        Helper.addClass(e, "animate");
        Helper.addClass(e, "animated");
      }
      Helper.loadImagesInDomElement(e);
    });

    this.handleScroll(elements);

    window.addEventListener("scroll", (e) => {
      this.handleScroll(elements);
    });
  }

  handleScroll(elements) {
    elements.forEach((e) => {
      if (Helper.isInViewport(e)) {
        Helper.addClass(e, "animated");
      } else {
        Helper.removeClass(e, "animated");
      }
    });
  }
}

export default ScrollAnimate;
